<template>
  <div class="content">
    <a-result class="result" :status="status" :subtitle="tip"> </a-result>
    <a-button type="primary" @click="back" v-show="isNoFound">返回首页</a-button>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from "vue";
  import { useRouter } from "vue-router";

  let tip = ref("");
  let status = ref("404");
  let isNoFound = ref(false);
  const router = useRouter();
  const checkRouter = () => {
    //判断路由树是否存在首页存在即认为有路由权限
    let homePermission = router.getRoutes().find((el) => el.name === "admin/home" || el.name === "app/index");
    if (homePermission) {
      isNoFound.value = true;
      tip.value = "找不到页面，请确认地址是否正确。";
      status.value = "404";
    } else {
      status.value = "403";
      tip.value = "无访问权限，请联系管理员。";
      isNoFound.value = false;
    }
  };
  const back = () => {
    // warning： Go to the node that has the permission
    router.replace({ path: "/home" });
  };
  checkRouter();
</script>

<style scoped lang="less">
  .content {
    // padding-top: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -95px;
    margin-top: -121px;
    text-align: center;
  }
</style>
